import * as PaymentActionCreators from 'actions/payment';
import * as FateActionCreators from 'actions/fate';

import * as phases from 'constants/phases';
import StoryletService from 'services/StoryletService';
import * as StoryletActionTypes from '../../actiontypes/storylet';

import addNewContact from 'actions/storylet/addNewContact';
import begin from 'actions/storylet/begin';
import beginSocialEvent from 'actions/storylet/beginSocialEvent';
import chooseBranch from './chooseBranch';
import createPlan from 'actions/storylet/createPlan';
import deletePlan from 'actions/storylet/deletePlan';
import fetchAvailable, { fetchAvailableSuccess } from 'actions/storylet/fetchAvailable';
import fetchIneligibleContacts from './fetchIneligibleContacts';
import goBack, { goBackSuccess } from './goBack';
import renameQuality from './renameQuality';
import sendSocialInvite, {
  sendSocialInviteRequested,
  sendSocialInviteSuccess,
  sendSocialInviteFailure,
} from './sendSocialinvite';
import tryAgain from './tryAgain';
import useQuality from './useQuality';

export {
  addNewContact,
  begin,
  beginSocialEvent,
  chooseBranch,
  createPlan,
  deletePlan,
  fetchAvailable,
  fetchAvailableSuccess,
  fetchIneligibleContacts,
  goBack,
  goBackSuccess,
  renameQuality,
  sendSocialInvite,
  tryAgain,
  useQuality,
};
export { default as finish } from './finish';
export { default as goOnwards } from './goOnwards';
export { default as suggestContact } from './suggestContact';

const storyletService = new StoryletService();


/** ----------------------------------------------------------------------------
 * SEND SOCIAL INVITATION
 -----------------------------------------------------------------------------*/
export const sendExternalSocialInvite = data => (dispatch) => {
  dispatch(sendSocialInviteRequested());
  storyletService.sendExternalSocialInvite(data).then((response) => {
    dispatch(sendSocialInviteSuccess(response.data));
  }).catch((error) => {
    dispatch(sendSocialInviteFailure(error));
  });
};

export const goBackFromSocialAct = () => ({
  type: StoryletActionTypes.GO_BACK_FROM_SOCIAL_ACT,
  payload: { phase: phases.IN },
  phase: phases.IN,
});

/** ----------------------------------------------------------------------------
 * CLEAR CACHE
 -----------------------------------------------------------------------------*/
export const clearCache = () => ({ type: StoryletActionTypes.CLEAR_CACHE });

/** ----------------------------------------------------------------------------
 * PUT IN
 -----------------------------------------------------------------------------*/
export const putIn = () => ({ type: StoryletActionTypes.PUT_IN });


/**-----------------------------------------------------------------------------
* CLOSE CANNOT USE DIALOG
------------------------------------------------------------------------------*/
export const closeCannotUseDialog = () => ({ type: StoryletActionTypes.CLOSE_CANNOTUSE_DIALOG });

export const openFatePurchase = (history) => {
  history.push('/fate');
  return (dispatch) => {
    dispatch(FateActionCreators.fetch());
    dispatch(PaymentActionCreators.openDialog('buy'));
    return {
      type: StoryletActionTypes.OPEN_FATE_PURCHASE,
    };
  };
};